import React from 'react';

import Loadable from 'react-loadable';

import { HiddenLoader } from 'src/components/react-loadable';

const LoadableRepoPullRequestOverviewPanel = Loadable({
  loading: HiddenLoader,
  loader: () => import('./repo-pull-request-overview-panel'),
});

export const LazyForgeRepoPullRequestOverviewPanel = (): JSX.Element | null => {
  return <LoadableRepoPullRequestOverviewPanel />;
};
